<template>
  <div :class="`personalCenter ${$store.state.isMobile ? '' : 'personalCenterPc'}`" @click="clickPage">
    <mobileBack type="white" v-if="$store.state.isMobile && !popShow" style="z-index: 222;"></mobileBack>
    <div class="nameWarp" v-if="$store.state.isMobile">
      <div class="innerBgColor"></div>
      <div class="phone">
        {{ $cookie.get('ticket_phone') || '未登录' }}
        <div class="loginOut" @click="loginOut"></div>
      </div>
    </div>
    <topBanner v-else></topBanner>
    <div class="pcToIndex" @click="toIndex" v-if="!$store.state.isMobile && !popShow">返回</div>
    <div class="pcToIndex backPc" @click="popShow = false" v-if="popShow && !$store.state.isMobile">返回</div>
    <div class="resetPassword" @click="resetPassword" v-if="!$store.state.isMobile && !popShow">修改密码</div>
    <div :class="$store.state.isMobile ? 'lineWarp' : 'pcContent'">
      <div :class="`line ${$store.state.isMobile ? '' : 'pc'}`" v-for="item in lines" :key="item.id"
        @click="clickItem(item.id)" v-show="!(!$store.state.isMobile && popShow)">
        {{ item.name }}
      </div>
      <div class="line" v-if="$store.state.isMobile" @click="resetPassword">修改密码</div>
      <pop v-if="showAdd && !$store.state.isMobile">
        <slot>
          <div class="popContent">
            <div class="popCloseIcon" @click="showAdd = false"></div>
            <div class="title">{{ popShow ? '详细信息' : '个人信息' }}</div>
            <div class="baseLine"></div>
            <div class="lineContent">
              <div class="name">{{ popShow == 4 ? '负责人' : '姓名' }}</div>
              <el-input v-model="addDetail.personName" placeholder="请输入姓名"
                :disabled="addDetail.personNameDisabled || addDetail.haveOrder"></el-input>
            </div>
            <div class="lineContent" v-if="popShow != 4">
              <div class="name">证件类型</div>
              <el-select v-model="addDetail.cardType" placeholder="请选择" :disabled="addDetail.haveOrder">
                <el-option v-for="item in cardTypes" :key="item.val" :label="item.name" :value="item.val">
                </el-option>
              </el-select>
            </div>
            <div v-else class="lineContent">
              <div class="name">团队名称</div>
              <el-input v-model="addDetail.orgName" placeholder="请输入团队名称" :disabled="addDetail.haveOrder"></el-input>
            </div>
            <div class="lineContent">
              <div class="name">{{ popShow == 4 ? '身份证号' : '证件号码' }}</div>
              <el-input v-model="addDetail.cardNum" placeholder="请输入证件号码"
                :disabled="popShow == 4 || addDetail.haveOrder"></el-input>
            </div>
            <div class="lineContent">
              <div class="name">联系电话</div>
              <el-input v-model="addDetail.phone" placeholder="请输入联系电话" type="number"
                oninput="if(value && value.length>11)value=value.slice(0,11)"
                :disabled="addDetail.phoneDisabled || addDetail.haveOrder"></el-input>
            </div>
            <div class="tips" v-if="addDetail.haveOrder">该用户有过历史订单，暂不支持修改基本信息</div>
            <div class="buttonConfirm" @click="!addDetail.haveOrder ? saveAddPerson(addDetail) : showAdd = false">
              {{ !addDetail.haveOrder ? '保存' : '关闭' }}</div>
          </div>
        </slot>
      </pop>
      <div :class="`${$store.state.isMobile ? 'contacts' : 'pcItemCard contactsPc'}`" v-if="popShow">
        <mobileBack v-if="$store.state.isMobile" :otherClick="true" @backOtherClick="backOtherClick"></mobileBack>
        <div class="title1" v-if="personals.length">{{ popShow == 2 ? '常用联系人' : '常用团队' }}</div>
        <div class="personalWarp">
          <personalCard v-for="(item, index) in personals" :key="item.id" :type="$store.state.isMobile ? '' : 'line'">
            <div slot="left" class="leftName">
              <div class="index">{{ index + 1 }}</div>
            </div>
            <div slot="right" class="rightContent">
              <!-- 个人 -->
              <div v-if="popShow != 4">
                <div class="detail">
                  <span class="title em2">姓名</span>
                  <span class="name">{{ item.personName }}</span>
                </div>
                <div class="detail">
                  <span class="title">手机号</span>
                  <span class="name">{{ item.phone }}</span>
                </div>
              </div>
              <!-- 团队 -->
              <div v-else>
                <div class="detail">
                  <span class="title">团队名称</span>
                  <span class="name">{{ item.orgName }}</span>
                </div>
                <div class="detail">
                  <span class="title">负责人&nbsp;&nbsp;&nbsp;</span>
                  <span class="name">{{ item.personName }}</span>
                </div>
              </div>
              <div class="buttons">
                <!-- <div class="button button_red" @click="del(item.id)" v-show="popShow == 2 && item.belongId">删除</div>
                <div class="button button_red" @click="dissolutionGroup(item)" v-if="popShow == 4">解散</div>
                <div class="button" @click="edit(item)">编辑</div> -->
                <div class="button button_red" @click="del(item.id)" v-if="popShow == 2 && item.belongId">删除</div>
                <div class="button button_red" @click="dissolutionGroup(item)" v-if="popShow == 4">解散</div>
                <div class="button" @click="edit(item)">编辑</div>
              </div>
            </div>
          </personalCard>
        </div>
        <div class="noData" v-if="!personals.length">暂无信息</div>
        <div class="backButton">
          <div class="buttonNormal" @click="addNew">{{ popShow == 2 ? '添加联系人' : '添加团队' }}</div>
        </div>
      </div>
    </div>
    <addCard v-if="showAdd && $store.state.isMobile" @handelShowAdd="handelShowAdd" @saveAddPerson="saveAddPerson"
      :cardTypes="cardTypes" :addDetail="addDetail" addType="personal" showTopBack="true" :editDetaiType="editDetaiType"
      :personals="[{}]" :isTeam="popShow == 4 ? true : false" @changeAddDetail="changeAddDetail"></addCard>
    <pop v-if="showPop">
      <slot style="height: 200px;">
        <div class="confirmContents">
          <div :class="{'confirmNotice':!fromBanner,'confirmNoticeBanner':fromBanner}" >您是否要退出登录？</div>
        </div>
        <div class="buttonWarp">
          <div :class="{'buttonCancel':!fromBanner,'buttonCancel buttonCancelBanner':fromBanner}" @click="closePop">否</div>
          <div  :class="{'buttonConfirm':!fromBanner,'buttonConfirm buttonConfirmBanner':fromBanner}"  @click="submitLoginOut">是</div>
        </div>
      </slot>
    </pop>
    <div :class="$store.state.isMobile ? '' : 'pcContent'" v-if="showDelConfirm">
      <pop>
        <slot>
          <div class="confirmText">{{ !confirmType ? '删除后信息将无法恢复，请确认是否删除？' : `是否确认解散${delItem.orgName}团队？` }}</div>
          <div class="buttonsWarp buttonsWarps">
            <div class="buttonCancel" @click="cancel">取消</div>
            <div class="buttonConfirm" @click="confirm">确定</div>
          </div>
        </slot>
      </pop>
    </div>
    <h5Bottom v-if="$store.state.isMobile" :activeIndex="2"></h5Bottom>
  </div>
</template>

<script>
import topBanner from '../../components/common/topBanner'
import addCard from '@/components/ticket/addCard'
import pop from '../../components/common/pop'
import personalCard from '../../components/common/personalCard.vue'
import mobileBack from '../../components/common/mobileBack'
import h5Bottom from '../../components/common/h5Bottom.vue'
var msg
export default {
  data() {
    return {
      lines: [{
        name: '基本信息',
        url: '',
        id: 1
      }, {
        name: '常用联系人',
        url: '',
        id: 2
      }, {
        name: '常用团队',
        url: '',
        id: 4
      }, {
        name: '个人预约记录',
        url: '',
        id: 5
      }, {
        name: '团队预约记录',
        url: '',
        id: 6
      }],
      cardTypes: [
        { name: '身份证', val: 1 },
        { name: '护照（Passport）', val: 2 },
        { name: '台胞证', val: 5 },
        { name: '军官证', val: 6 },
        { name: '外国人永居证', val: 7 },
        { name: '港澳居民来往内地通行证', val: 3 },
      ],
      userInfo: {},
      editDetaiType: 'add',
      showAdd: false,
      hasClick: false,
      popShow: '',
      personals: [],
      teams: [],
      addDetail: {},
      showGroupDetail: false,
      team: {
        members: []
      },
      showPop: false,
      hasGetUserInfo: false,
      showDelConfirm: false,
      delItem: {},
      confirmType: 'group', //弹窗确认类型
      fromRouter: '',
      that: this,
      themetimer: null,
      fromBanner:false
    };
  },
  components: { topBanner, addCard, pop, personalCard, h5Bottom, mobileBack },

  beforeRouteEnter(to, from, next) {
    localStorage.setItem('fromRouter', from.name)
    // this.fromRouter=from.name
    // console.log(from.name)
    next()
    // ...
  },
  methods: {
    closePop() {
      this.showPop = false
    },
    clickPage() {
      if (msg) {
        msg.close()
        console.log(msg)
        this.$message.close()
      }
    },
    submitLoginOut() {
      this.$cookie.delete('token')
      this.$cookie.delete('ticket_phone')
      this.$router.replace(`/ticket/login?museumCode=${this.$store.state.museumCode}${this.$route.query.id ? `&id=${this.$route.query.id}` : ''}${this.$route.query.code ? `&code=${this.$route.query.code}` : ''}`)
    },
    toIndex() {
      let fromRouter = ''
      fromRouter = localStorage.getItem('fromRouter')
      let query = this.$route.query
      if (fromRouter === 'reservation') {
        this.$router.back()
      } else {
        this.$router.push({ path: '/ticket/home', query })
      }
    },
    loginOut() {
      this.showPop = true
      // this.$cookie.delete('token')
      // location.href = `http://passport2.chaoxing.com/logout.html?refer=${location.origin}${location.pathname}#/ticket/login?museumCode=${this.$store.state.museumCode}${this.$route.query.id ? `&id=${this.$route.query.id}` : ''}${this.$route.query.code ? `&code=${this.$route.query.code}` : ''}`
    },
    clickItem(type) {
      this.personals = []
      this.popShow = ''
      // console.log(type)
      // console.log(this.userInfo.id)
      let id = sessionStorage.getItem('userInfoId')
      console.log(id)
      if ((type == 2 || type == 4) && !id) return this.$message('请先填写基本信息！')
      switch (type) {
        case 1:
          this.showAdd = true
          this.addDetail = this.userInfo
          if (this.$store.state.userPhone && !this.userInfo.id) {
            this.addDetail.phone = this.$store.state.userPhone
          }
          this.addDetail.phoneDisabled = true
          break;
        case 2:
          this.popShow = 2
          this.getContacts()
          break;
        case 4:
          this.popShow = 4
          this.getContacts()
          break;
        case 5:
        case 6:
          let query = this.$route.query
          query.orderType = type == 5 ? 2 : 1
          this.$router.push({ path: '/ticket/ordersNew', query })
          break;
        default:
      }
    },

    // 重置密码
    resetPassword() {
      let query = this.$route.query
      query.loginType = 2
      this.$router.push({ name: 'login', query })
    },
    // 返回
    backOtherClick() {
      this.popShow = false
    },
    // 根据id获取未脱敏的数据
    changeAddDetail(res) {
      this.addDetail = res
      if (this.addDetail.phone == this.$store.state.userPhone) {
        this.addDetail.phoneDisabled = true
      }
    },
    dissolutionGroup(item) {
      this.confirmType = 'confirmType'
      this.showDelConfirm = true
      this.delItem = item

    },

    cancel() {
      this.showDelConfirm = false
    },
    getOrders(status) {
      // let orders = []
      // let orderPeoples = []
      // let orderType=1
      // let url=`/api/ticket/front/order/my-order?museumCode=${this.$route.query.museumCode}&orderType=1&ticketId=${this.$route.query.id}&orderStatus=1`
      // // let url=`/api/ticket/front/order/detail?ticketOrderId=${this.$route.query.orderId}`
      // this.$ajax(url).then((res) => {
      //   console.log(res)
      // })


    },
    confirm() {
      this.showDelConfirm = false
      console.log(this.delItem.id)
      if (!this.confirmType) { //删除常用联系人
        this.$ajax.delete(`/api/ticket/front/people/${this.delItem.id}`).then((res) => {
          if (res.rel) {
            this.$message.success({ message: '删除成功', showClose: true, duration: 1000, center: true })
            this.getContacts()
          }
        })
        return
      }
      // 解散团队
      this.$ajax.delete(`/api/ticket/front/people/disband-team?id=${this.delItem.id}`).then((res) => {
        this.$message.success({ message: '解散成功', showClose: true, duration: 1000, center: true })
        this.getContacts()
      })
    },

    handelShowAdd() {
      this.showAdd = false
    },

    // 删除常用
    del(id, type) {
      this.delItem = {
        id
      }
      this.showDelConfirm = true
      this.confirmType = ''
    },

    // 编辑
    edit(item) {
      this.addDetail = JSON.parse(JSON.stringify(item))
      console.log('add')
      console.log(this.addDetail)
      // this.getDetailInfo()
      this.showAdd = true
      if (this.$store.state.isMobile) return
      this.addDetail.id ? this.getDetailInfo() : ''
    },

    getDetailInfo() {
      if (this.addDetail.phone == this.$cookie.get('ticket_phone')) {
        this.addDetail.phoneDisabled = true
      }
      this.$ajax.get(`/api/ticket/front/people/get-by-id?id=${this.addDetail.id}`).then((res) => {
        res = res.data
        console.log('re111s')
        console.log(res)
        this.addDetail.cardNum = res.cardNum
        this.addDetail.phone = res.phone
        this.addDetail.haveOrder = res.haveOrder
      })
    },

    // 新增
    addNew(type) {
      this.addDetail = {}
      this.showAdd = true
      if (this.popShow != 4) return
      // 团队预约新增自动带手机号
      if (this.$store.state.userPhone) {
        this.addDetail.phone = this.$store.state.userPhone
        this.addDetail.phoneDisabled = true
      }
      // 团队预约自动带账号
      if (this.userInfo.id) {
        this.addDetail.phone = this.userInfo.phone
        this.addDetail.cardNum = this.userInfo.cardNum
        this.addDetail.personName = this.userInfo.personName
        this.addDetail.phoneDisabled = true
        this.addDetail.personNameDisabled = true
      }
    },

    // 保存编辑或者新增的数据
    saveAddPerson(data) {

      if (this.hasClick) return
      // let emptyLength = 4
      // if (Object.keys(data).length < emptyLength) return this.$message.error('请将基础信息填写完整！') 
      console.log(data)
      // if (this.popShow == 4) {//团队新增
      //   if (!data.cardNum || !data.orgName || !data.phone || !data.personName) {
      //     return this.$message.warning('请将基础信息填写完整！')
      //   }
      //   if (!data.cardNum || !data.personName || !data.phone)  {return this.$message.warning('请将基础信息填写完整！')}
      // }
      if (this.popShow == 4) {//团队新增
        if (!data.cardNum || !data.orgName || !data.phone || !data.personName) return this.$message.warning('请将基础信息填写完整！')
      } else { //联系人新增
        if (!data.cardNum || !data.personName || !data.phone) return this.$message.warning('请将基础信息填写完整！') 
      }
      if (!/^1[3|4|5|6|7|8|9][0-9]\d{8}$/.test(data.phone)) {
        this.$message.warning('请输入正确的手机号')
       
      }

      if (data.id) {
        return this.postPersonal(data)
      }
      // 个人：2，团队：4
      data.personType = this.popShow ? this.popShow : 2
      if (this.popShow == 2 && this.userInfo.id) data.belongId = this.userInfo.id
      // 常用团队增加常用字段
      if (this.popShow == 4) {
        data.cardType = 1
        data.common = true
      }
      this.postPersonal(data, 'add')
    },

    postPersonal(data, type) {
      this.hasClick = true
      if (type == 'add') { //新增
        data.museumCode = this.$route.query.museumCode
        this.$ajax.post('/api/ticket/front/people', data).then((res) => {
          this.hasClick = false
          this.showAdd = false
          this.getContacts()
          if (this.userInfo.id) return
          this.getUserInfo()
        }).catch(() => {
          this.hasClick = false
        })
        return
      }
      // 编辑
      this.$ajax.put('/api/ticket/front/people', data).then((res) => {
        this.hasClick = false
        this.showAdd = false
        this.getContacts()
      }).catch(() => {
        this.hasClick = false
      })
    },

    // 获取个人信息（type为2的信息）
    getUserInfo() {
      // 获取手机号
      this.$ajax('/api/ticket/front/people/get-phone').then((res) => {
        this.$store.state.userPhone = res.data
        this.$ajax(`/api/ticket/front/people/belong-info?museumCode=${this.$route.query.museumCode}&personType=2`).then((res) => {
          let t = !res.data || !res.data.length
          if (!t) return this.getUserInfoDetail(res.data[0].id)
          //没有过常用联系人
          //
        })
      })
    },

    // 根据id获取未脱敏的数据
    getUserInfoDetail(id) {
      this.editDetaiType = 'edit'
      this.$ajax.get(`/api/ticket/front/people/get-by-id?id=${id}`).then((res) => {
        res = res.data
        this.addDetail = res
        this.userInfo = res
        console.log('res1111')
        console.log(res)
        sessionStorage.setItem('userInfoId', res.id)
        this.addDetail.phoneDisabled = true
      })
    },

    // 获取常用联系人
    getContacts(type) {// 2个人 4团队
      if (!this.userInfo.id) return
      let url = this.popShow == 2 ? `/api/ticket/front/people/info?museumCode=${this.$route.query.museumCode}&belongId=${this.userInfo.id}&personType=${this.popShow}` : `/api/ticket/front/people/common?museumCode=${this.$route.query.museumCode}&type=2`
      this.$ajax(url).then((res) => {
        this.personals = res.data
      })
    }
  },

  created() {
    this.getUserInfo()
    this.getOrders(0)
  },
  beforeDestroy() {
    if (msg) {
      msg.close()
    }
  },

  computed: {

  },
  mounted () {
    let that = this
    // 更新个人中心 顶部及背景
    this.themetimer = setInterval(() => {
      if (Object.keys(this.$store.state.themeData).length > 0) {
        clearInterval(that.themetimer)
        let topbg = that.$store.state.themeData.apppersontop
        if (topbg && topbg.length > 0) {
          document.querySelector('.nameWarp').style.backgroundImage = `url('${topbg[0].fileUrl}')`
          document.querySelector('.nameWarp').style.backgroundSize = `100% 100%`
        }
        let bg = that.$store.state.themeData.apppersonbg
        if (bg && bg.length > 0) {
          document.querySelector('.personalCenter').style.backgroundImage = `url('${bg[0].fileUrl}')`
          document.querySelector('.personalCenter').style.backgroundSize = `100% 100%`
        }
      }
    }, 100)
  }
}
</script>

<style scoped lang="scss">
.rightContent .detail .name{
  width: calc(100% - 3rem);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.personalCenter {
  background: #99999921;
  min-height: 100vh;

  &.personalCenterPc {
    min-width: 1200px;
    background: url('../../assets/images/homeBg.jpg') 0 0/cover no-repeat;

    .contactsPc {
      .rightContent {
        .detail {
          font-size: 0;

          span {
            vertical-align: middle;
          }
        }

        .detail .name {
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          width: 200px;
          display: inline-block;
          vertical-align: middle;
        }
      }
    }
  }

  .confirmContents {
    margin-top: 0.5rem;
    margin-bottom: 0.3rem;

    .confirmNotice {
      font-size: 0.5rem;
    }
    .confirmNoticeBanner{
      font-size: 0.2rem;
    }
  }

  .buttonWarp {
    display: flex;
    justify-content: center;
    align-items: center;
    .buttonCancelBanner{
      scale: 0.4;
    }
    .buttonConfirmBanner{
      scale: 0.4;
    }
 
  }

  .confirmText {
    font-weight: 500;
    margin: 0.5rem 0;
    font-size: 0.6rem;
  }

  .buttonsWarps {
    margin-top: 0.5rem;
  }

  .nameWarp {
    height: 2rem;
    padding-top: 1.6rem;
    margin-bottom: 1rem;

    .phone {
      margin: 0 0.4rem;
      line-height: 2rem;
      font-size: 0.45rem;
      padding-left: 2rem;
      text-align: left;
      background-color: #fff;
      border-top-left-radius: 0.12rem;
      border-top-right-radius: 0.12rem;
      position: relative;

      &:before {
        position: absolute;
        content: '';
        display: inline-block;
        height: 1.2rem;
        width: 1.2rem;
        top: 0.4rem;
        left: 0.5rem;
      }
    }

    .loginOut {
      position: absolute;
      width: 0.8rem;
      height: 0.8rem;
      background: url('../../assets/ticket/loginout.png') 0 0/contain no-repeat;
      right: 0.5rem;
      margin: 0;
      border: 0;
      top: 0.63rem;
    }
  }

  .line {
    height: 1.4rem;
    font-size: 0.4rem;
    line-height: 1.4rem;
    background: #fff;
    margin: 0.4rem;
    padding-left: 1.6rem;
    text-align: left;
    border-radius: 0.1rem;
    position: relative;
    cursor: pointer;

    &:before,
    &:after {
      position: absolute;
      content: '';
      display: inline-block;
      height: 0.5rem;
      width: 0.5rem;
      top: 0.42rem;
      left: 0.7rem;
    }

    &:nth-child(1):before {
      -webkit-mask: url('~@/assets/ticket/user.svg') 0 0/100% 100% no-repeat;
      mask: url('~@/assets/ticket/user.svg') 0 0/100% 100% no-repeat;
    }

    &:nth-child(2):before {
      height: 0.6rem;
      width: 0.6rem;
      top: 0.38rem;
      -webkit-mask: url('~@/assets/ticket/member.svg') 0 0/100% 100% no-repeat;
      mask: url('~@/assets/ticket/member.svg') 0 0/100% 100% no-repeat;
    }

    &:nth-child(3):before {
      height: 0.6rem;
      width: 0.6rem;
      top: 0.38rem;
      -webkit-mask: url('~@/assets/ticket/users.svg') 0 0/100% 100% no-repeat;
      mask: url('~@/assets/ticket/users.svg') 0 0/100% 100% no-repeat;
    }

    &:nth-child(4):before,
    &:nth-child(5):before {
      height: 0.6rem;
      width: 0.6rem;
      top: 0.38rem;
      -webkit-mask: url('~@/assets/ticket/record.svg') 0 0/100% 100% no-repeat;
      mask: url('~@/assets/ticket/record.svg') 0 0/100% 100% no-repeat;
    }

    &:nth-child(6):before {
      height: 0.6rem;
      width: 0.6rem;
      top: 0.38rem;
      -webkit-mask: url('~@/assets/ticket/password.svg') 0 0/100% 100% no-repeat;
      mask: url('~@/assets/ticket/password.svg') 0 0/100% 100% no-repeat;
    }
  }

  .pcToIndex {
    left: calc(50vw - 605px);
    top: calc(100px + 36px);
    position: absolute;
  }

  .resetPassword {
    right: calc(50vw - 585px);
    top: calc(100px + 36px);
    position: absolute;
    font-size: 16px;
    cursor: pointer;
    background: #8D1010;
    width: 112px;
    height: 42px;
    border-radius: 21px;
    line-height: 42px;
    color: #FFE4BC;
  }

  .lineWarp {
    padding-bottom: 2rem;
  }

  .contacts {
    width: 100vw;
    height: calc(100vh - 1.5rem);
    overflow-y: scroll;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 2;
    background: #fff;
    padding-bottom: 2rem;

    .personalWarp {
      width: 100vw;

      .detail {
        span {
          display: inline-block;
          vertical-align: middle;
        }
      }

      .groupName {
        display: inline-block;
        width: 4rem;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
    }

    .backButton {
      position: fixed;
      bottom: 0rem;
      left: 0rem;
      height: 1.5rem;
      font-size: 0.4rem;
      display: flex;
      justify-content: center;
      align-items: center;
      // padding-left: 2.8rem;
      right: 0;
      background: #FFFDFA;
      border-top: 0.01rem solid #E4CEAE;
      box-shadow: 0px -3px 18px 0px #c4c4c475;

      .buttonNormal {
        margin: 0;
      }

      .back {
        line-height: .7rem;
        font-size: .4rem;
        border: 1px solid rgba(114, 106, 106, .8);
        padding: 0 0.3rem;
        border-radius: 0.2rem;
        color: rgba(114, 106, 106, .8);
        margin-right: 0.3rem;
      }

      .buttonNormal {
        margin: 0;
      }
    }

    .title1 {
      font-size: 0.5rem;
      margin: 0.5rem 0;
      margin-left: 0.15rem;
      margin-top: -0.2rem;
    }

    .title2 {
      margin: 0.5rem;
      font-size: 0.45rem;
      font-weight: bold;
      text-align: left;
    }

    .leftName {
      writing-mode: horizontal-tb;
      height: 2.5rem;

      .index {
        padding-top: 0.9rem;
      }
    }

    .em2 {
      letter-spacing: 0.5em;
    }

    .buttons {
      display: flex;
      justify-content: flex-end;
      align-content: center;
      margin-right: 0.3rem;
      cursor: pointer;

      .button {
        width: 1rem;
        line-height: 0.8rem;
        height: 0.8rem;
        font-size: 0.4rem;
        margin-right: 0.2rem;

        &.button_red {
          color: #a22424;
        }
      }
    }
  }

  .noData {
    text-align: center;
    font-size: 0.4rem;
    margin-top: 3rem;
  }

  .pc {
    &.line {
      width: 200px;
      padding-left: 0px;
      display: inline-block;
      margin: 20px 0;
      height: 220px;
      line-height: 300px;
      font-size: 24px;
      margin-right: 45px;
      text-align: center;
      margin-top: calc(50vh - 260px);
      color: #fff;

      &:after {
        height: 30px;
        width: 30px;
        left: 83px;
        top: 64px;
      }

      &:before {
        height: 60px !important;
        width: 60px !important;
        left: 70px !important;
        background-color: #fff !important;
        -webkit-mask: url('~@/assets/images/user_bg.svg') 0 0/100% 100% no-repeat;
        mask: url('~@/assets/images/user_bg.svg') 0 0/100% 100% no-repeat;
      }

      &:nth-child(1):after {
        -webkit-mask: url('~@/assets/images/icon_1.svg') 0 0/100% 100% no-repeat;
        mask: url('~@/assets/images/icon_1.svg') 0 0/100% 100% no-repeat;
      }

      &:nth-child(2):after {
        -webkit-mask: url('~@/assets/images/icon_3.svg') 0 0/100% 100% no-repeat;
        mask: url('~@/assets/images/icon_3.svg') 0 0/100% 100% no-repeat;
        left: 84px !important;
      }

      &:nth-child(3):after {
        -webkit-mask: url('~@/assets/images/icon_4.svg') 0 0/100% 100% no-repeat;
        mask: url('~@/assets/images/icon_4.svg') 0 0/100% 100% no-repeat;
        left: 88px !important;
      }

      &:nth-child(4):after {
        -webkit-mask: url('~@/assets/images/icon_5.svg') 0 0/100% 100% no-repeat;
        mask: url('~@/assets/images/icon_5.svg') 0 0/100% 100% no-repeat;
        left: 85px !important;
      }

      &:nth-child(5):after {
        -webkit-mask: url('~@/assets/images/icon_2.svg') 0 0/100% 100% no-repeat;
        mask: url('~@/assets/images/icon_2.svg') 0 0/100% 100% no-repeat;
        left: 85px !important;
      }

      &:nth-child(5) {
        margin-right: 0
      }

      &:before {
        position: absolute;
        content: '';
        display: inline-block;
        height: 55px;
        width: 55px;
        top: 50px;
        left: 70px;
      }
    }
  }

  .popWarp .tips {
    font-size: 18px;
    line-height: 36px;
    margin-top: 15px;
    text-align: left;
    margin-left: 30px
  }

  .backPc {
    left: calc(50vw - 510px);
  }

  .contactsPc {
    background: rgba(0, 0, 0, 0);
    padding-top: 0;
    box-shadow: unset;

    .personalWarp {
      display: flex;
      flex-wrap: wrap;
      // text-align: left;
    }

    .back {
      position: fixed;
    }

    .title1 {
      font-size: 30px;
      margin-bottom: 20px;
    }

    &.pcItemCard {
      margin-bottom: 0;
    }

    .personalCard {
      width: 46%;
      height: 180px;
      margin: 30px 6% 30px 0;

      // display: inline-flex;
      &:nth-child(2n) {
        margin-right: 0;
      }

      .leftName {
        writing-mode: horizontal-tb;
        height: 120px;
        line-height: 120px;
        max-width: 80px;
        text-align: center;
        width: 100%;
        margin-left: 5px;
        font-size: 28px;

        .index {
          padding-top: 40px;
          font-size: 25px;
          line-height: 40px;
        }
      }

      .buttons {
        display: flex;
        justify-content: flex-end;
        align-content: center;
        margin-right: 10px;
        cursor: pointer;
        margin-top: 20px;

        .button {
          width: 55px;
          line-height: 40px;
          height: 40px;
          font-size: 24px;
          margin-right: 25px;
          color: #333;

          &.button_red {
            color: #a22424;
          }
        }
      }
    }

    .backButton {
      position: absolute;
      right: calc(50vw - 510px);
      top: calc(100px + 29px);
      padding: 0;
      display: flex;
      justify-content: space-between;
      align-items: center;
      cursor: pointer;

      .buttonNormal {
        margin: 0;
        margin-left: 0;
        width: 150px;
        height: 50px;
        font-size: 20px;
        line-height: 50px;
      }
    }

    .noData {
      font-size: 0.2rem;
      margin-top: 1rem;
    }
  }
}
</style>
<style type="text/css" lang="scss">
.contactsPc {
  .personalCard .leftLine {
    padding: 0 30px !important;
    min-height: 100px !important;
    height: 120px;
    width: 50px !important;
    max-width: 80px !important;
    text-align: center;
    // padding-left: 30px !important;
  }

  .personalCard .right {
    padding: 0;
  }

}

.personalCenterPc .pcContent .popWarp .lineContent .name {
  font-size: 20px;
}

.personalCenterPc .popContent .lineContent .cardName {
  font-size: 20px;
  padding-left: 0.1rem;
}

.personalCenterPc .popContent .lineContent .el-input__inner {
  font-size: 20px;
  border-radius: 8px;
  border: 1px solid #E4E2E0;
  line-height: 55px;
  height: 55px;
}
</style>